/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as LoginblockIndexImport } from './routes/loginblock/index'
import { Route as LoginIndexImport } from './routes/login/index'

// Create/Update Routes

const LoginblockIndexRoute = LoginblockIndexImport.update({
  id: '/loginblock/',
  path: '/loginblock/',
  getParentRoute: () => rootRoute,
} as any)

const LoginIndexRoute = LoginIndexImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginIndexImport
      parentRoute: typeof rootRoute
    }
    '/loginblock/': {
      id: '/loginblock/'
      path: '/loginblock'
      fullPath: '/loginblock'
      preLoaderRoute: typeof LoginblockIndexImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/login': typeof LoginIndexRoute
  '/loginblock': typeof LoginblockIndexRoute
}

export interface FileRoutesByTo {
  '/login': typeof LoginIndexRoute
  '/loginblock': typeof LoginblockIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/login/': typeof LoginIndexRoute
  '/loginblock/': typeof LoginblockIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/login' | '/loginblock'
  fileRoutesByTo: FileRoutesByTo
  to: '/login' | '/loginblock'
  id: '__root__' | '/login/' | '/loginblock/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  LoginIndexRoute: typeof LoginIndexRoute
  LoginblockIndexRoute: typeof LoginblockIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  LoginIndexRoute: LoginIndexRoute,
  LoginblockIndexRoute: LoginblockIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/login/",
        "/loginblock/"
      ]
    },
    "/login/": {
      "filePath": "login/index.tsx"
    },
    "/loginblock/": {
      "filePath": "loginblock/index.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
